import {getTranslation} from "domain/helpers/translations";
import {LEVEL} from "components/ImpactBadge";

export const fields = {
    DESCRIPTION: 'description',
    PICTURE: 'image',
    PICTURES: 'images',
    CATEGORIES: 'categories',
}

export function getFieldToEnrich(product) {
    if (!product) return null;

    const translation = getTranslation(product);
    if (!translation || !translation.description || translation.description.trim() === '') {
        return fields.DESCRIPTION
    }

    if (!product.categories || product.categories.length === 0) {
        return fields.CATEGORIES
    }

    if (!product.variations || product.variations.length === 0) {
        // If there are no variations, we consider pictures are missing
        return fields.PICTURES
    }

    const hasOnlyOneVariationPicture = product.variations.some(variation => {
        return variation.pictures && variation.pictures.length === 1;
    });

    if (hasOnlyOneVariationPicture) {
        return fields.PICTURE
    }

    return null;
}

export function getImpactByField(field) {
    switch (field) {
        case fields.DESCRIPTION:
        case fields.PICTURES:
        case fields.CATEGORIES:
            return LEVEL.HIGH;
        case fields.PICTURE:
            return LEVEL.MEDIUM;
        default:
            return LEVEL.LOW;
    }
}

export function getFakeIASuggestionByField(field, random = null) {
    const suggestion =  {
        [fields.PICTURE]: 'Image secondaire manquante',
        [fields.PICTURES]: 'Image principale manquante — scraping recommandé',
        [fields.CATEGORIES]: 'Catégorie manquante',
        [fields.DESCRIPTION]: [
            'Adoptez un look intemporel avec cet article qui allie confort et élégance, parfait pour toutes les occasions.',
            'Découvrez la fusion parfaite entre style contemporain et fonctionnalité, conçu pour s\'adapter à votre rythme de vie.',
            'Ce vêtement exceptionnel est idéal pour ceux qui souhaitent se démarquer tout en profitant d\'une sensation de bien-être.',
            'Élevez votre garde-robe avec cette pièce polyvalente qui s\'adapte à tous les moments de la journée, du matin au soir.',
            'Conçu avec soin, cet article offre une allure raffinée tout en garantissant une liberté de mouvement inégalée. ',
            'Offrez-vous le luxe d\'un style unique avec ce vêtement qui incarne à la fois sophistication et praticité. ',
            'Laissez-vous séduire par la qualité supérieure de ce produit, alliant matériaux de choix et design innovant.',
            'Exprimez votre personnalité grâce à cette pièce audacieuse qui apporte une touche de fraîcheur à n\'importe quelle tenue.',
            'Restez à la pointe de la mode avec cet article fashion qui promet d\'être un incontournable dans votre collection.',
            'Ce vêtement, pensé pour le quotidien, garantit élégance et confort, vous permettant de briller en toute simplicité.'
        ]
    }

    if (field === fields.DESCRIPTION) {
        if (random === null) {
            random =  Math.floor(Math.random() * 10);
        }

        return suggestion[fields.DESCRIPTION][random];
    }

    return suggestion[field]
}

